<template>
  <v-window-item :value="value">
    <v-card
      flat
      :light="light"
      :color="color"
      max-width="380"
      rounded="xl"
      class="mx-auto"
    >
      <slot />
    </v-card>
  </v-window-item>
</template>

<script>
  export default {
    props: {
      value: {
        required: true,
        type: String,
      },
      light: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    computed: {
      color () {
        return this.light ? 'grey lighten-3' : '#372e2a'
      },
    },
  }
</script>
